/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneFacebook from 'base/components/standalone/Facebook';

export const DynamicStandaloneFacebook = StandaloneFacebook;
export type DynamicStandaloneFacebookProps = PropsFromComponent<typeof StandaloneFacebook>;

export const DynamicStandaloneFacebookWith = (extras: DynamicStandaloneExtras): typeof StandaloneFacebook => {
    return function DynamicStandaloneFacebook(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Facebook');
        return <StandaloneFacebook {...mergeProps({ options: { theme } }, props)} />;
    }
}